











import { Vue, Component } from "@/shared/vuepack";

@Component
export default class UmbFooterInvestment extends Vue {
}
